import { useState } from "react";
import { Heading, Fieldset, Input, Box, Container } from "@chakra-ui/react";
import { Button } from "@/components/ui/button";
import { PageContent, PageHeader, PageLayout } from "@/components/page";
import { Field } from "@/components/ui/field";
import { useChangePassword } from "@/hooks";

function ChangePassword() {
  const { changePassword, isPending, error } = useChangePassword();
  const [password, setPassword] = useState<string>("");
  const [password2, setPassword2] = useState<string>("");
  const [oldPassword, setOldPassword] = useState<string>("");

  const validatePassword = (p: string) =>
    p.length >= 8 &&
    /\d+/.test(p) &&
    /[a-z]+/.test(p) &&
    /[A-Z]+/.test(p) &&
    /\W+/.test(p) &&
    !/\s+/.test(p);

  return (
    <PageLayout>
      <PageHeader backLink="/">Change Password</PageHeader>
      <PageContent>
        <Container maxW="2xl">
          <Heading py="4" size="3xl">Change Password</Heading>
          <Fieldset.Root>
            <Field label="Current password" required>
              <Input
                type="password"
                onChange={(e) => setOldPassword(e.target.value)}
              />
            </Field>
            <Field
              label="New password"
              required
              invalid={password === "" ? false : !validatePassword(password)}
              helperText="Must be at least 8 characters long, with at least one number, one uppercase letter, one lowercase letter, and one special character."
            >
              <Input
                type="password"
                onChange={(e) => setPassword(e.target.value)}
              />
            </Field>
            <Field
              label="Confirm new password"
              required
              disabled={!password}
              invalid={password2 === "" ? false : password !== password2}
              helperText={
                !password2
                  ? false
                  : !validatePassword(password)
                    ? "New password does not meet requirements"
                    : password !== password2 && "Passwords do not match"
              }
            >
              <Input
                type="password"
                onChange={(e) => setPassword2(e.target.value)}
              />
            </Field>
            <Button
              type="submit"
              onClick={() =>
                changePassword({ old_password: oldPassword, password, password2 })}
              disabled={
                !oldPassword ||
                !validatePassword(password) ||
                password !== password2
              }
              colorPalette="blue"
              loading={isPending}
              loadingText="Changing password..."
            >
              Change Password
            </Button>
            {error && (
              <Box color="red">
                It was not possible to change your password. Please check if your
                current password is correct.
              </Box>
            )}
          </Fieldset.Root>
        </Container>
      </PageContent>
    </PageLayout>
  );
}

export default ChangePassword;
